import * as Tooltip from "@radix-ui/react-tooltip"
import React, { FC, useState } from "react"

type ToolTipProps = {
  trigger: React.ReactNode
  children: React.ReactNode
  offset?: number
  alignOffset?: number
  triggerAsChild?: boolean
  wrapperClassName?: string
}

export const ToolTip: FC<ToolTipProps> = ({
  children,
  trigger,
  offset = 10,
  alignOffset = 0,
  triggerAsChild = false,
  wrapperClassName,
}) => {
  const [open, setOpen] = useState(false)

  return (
    <Tooltip.Root open={open} onOpenChange={setOpen}>
      <Tooltip.Trigger
        onClick={toggleOpen}
        asChild={triggerAsChild}
        className={wrapperClassName}
      >
        {trigger}
      </Tooltip.Trigger>
      <Tooltip.Portal>
        <Tooltip.Content
          side="top"
          avoidCollisions
          alignOffset={alignOffset}
          sideOffset={offset}
          className="z-100 ml-[-5px] w-[calc(100%+10px)] rounded-md bg-shade-600 px-4 py-3.5"
        >
          {children}
          <Tooltip.Arrow className="fill-shade-600" />
        </Tooltip.Content>
      </Tooltip.Portal>
    </Tooltip.Root>
  )

  function toggleOpen() {
    setOpen((open) => !open)
  }
}
